// extracted by css-extract-rspack-plugin
export default {"checkNameButton":"u8jsTBwRvtAMoZgg"};